import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Gvc } from "../../schema/types/gvc/entity";

export const gvcApi = createApi({
  reducerPath: "gvcApi",
  baseQuery: customBaseQuery,
  tagTypes: ["AllGvcs", "Gvc"],
  endpoints: (builder) => ({
    listAllGvcs: builder.query<Gvc[], string>({
      queryFn: async (orgName) => {
        try {
          let nextLink: string | undefined = `/org/${orgName}/gvc`;
          let items: Gvc[] = [];
          while (nextLink) {
            const { request, linksOf } = await import("../../services/cpln");
            const { data } = await request({ url: nextLink });
            items = items.concat(data.items);
            nextLink = linksOf(data).next;
          }
          return { data: items };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: () => [{ type: "AllGvcs" }],
    }),
    getGvc: builder.query<Gvc, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Gvc", id: link }],
    }),
  }),
});

export const { useGetGvcQuery, useListAllGvcsQuery, useLazyGetGvcQuery } = gvcApi;
